<template>
  <PortableText
    class-name="c-rich-text"
    :blocks="blocks"
    :serializers="serializers"
    :project-id="blockOptions.projectId"
    :dataset="blockOptions.dataset"
  />
</template>

<script>
// TODO: V3 migration -> https://github.com/portabletext/vue-portabletext/blob/main/MIGRATING.md
import blocksToHTML from '@sanity/block-content-to-html'
import PortableText from 'sanity-blocks-vue-component'

// portableText serializers
import AudioBlock from '@/components/block/AudioBlock'
import ClickableImageBlock from '@/components/block/ClickableImageBlock'
import FigureBlock from '@/components/block/FigureBlock'
import AdBlock from '@/components/block/AdBlock'
import VideoBlock from '@/components/block/VideoBlock'
import YouTubeBlock from '@/components/block/YouTubeBlock'

// const h = blocksToHTML.h

export default {
  name: 'RichText',

  components: {
    // AdBlock,
    // AudioBlock,
    // FigureBlock,
    // VideoBlock,
    // YouTubeBlock,
    PortableText
  },

  props: {
    blocks: {
      type: Array,
      required: true
    }
  },

  data: function () {
    return {}
  },

  computed: {
    blockOptions() {
      return {
        projectId: this.tenant.cms.projectId,
        dataset: this.tenant.cms.dataset,
        useCdn: true
      }
    },

    serializers() {
      return {
        styles: {
          normal: ({ _style, _children }) => {}
        },
        marks: {
          highlight: ({ _mark, children }) => {
            // eslint-disable-next-line no-unused-vars
            /*
            const vNode = h(
              'pre',
              {},
              h('span', { style: { 'background-color': 'yellow', 'color': 'black' } }, children)
            )
            */

            return <span style={{ backgroundColor: 'yellow', color: 'black' }}>{children}</span>
          },

          left: ({ children }) => <div className="text-left">{children}</div>,
          center: ({ children }) => <div className="text-center">{children}</div>,
          right: ({ children }) => <div className="text-right">{children}</div>,

          externalLink: ({ mark, children }) => {
            const { href } = mark
            // eslint-disable-next-line no-unused-vars
            // const vNode = h('a', { href, target: '_blank', rel: 'noopener noreferrer' }, children)
            return (
              <a href={href} target="_blank" rel="noopener noreferrer">
                {children}
              </a>
            )
          },

          internalLink: ({ mark, children }) => {
            const linkedType = mark.linkedType || 'content'
            const id = mark.id
            const slug = mark.slug

            const paths = {
              channel: `/ichannel/${slug}`,
              content: `/iplayer/${id}`,
              post: `/ipost/${id}`
            }

            const path = paths[linkedType] || ''

            return <router-link to={path}>{children}</router-link>
          }
        },

        types: {
          inlineAd: AdBlock,
          audio: AudioBlock,
          clickableImage: ClickableImageBlock,
          figure: FigureBlock,
          video: VideoBlock,
          youtube: YouTubeBlock
        }
      }
    },

    tenant() {
      return this.$store.state.tenantStore.tenant
    }
  },

  methods: {
    toHTML(blocks) {
      return blocksToHTML({
        blocks,
        serializers: this.serializers,
        projectId: this.tenant.cms.projectId,
        dataset: this.tenant.cms.dataset,
        useCdn: true
      })
    },

    toText() {
      const text = []
      this.blocks[0].children?.forEach((child) => text.push(child.text))
      return text.join('')
    }
  }
}
</script>

<style lang="css" scoped>
.c-rich-text {
  width: 100%;
}

p,
:deep(p) {
  font-size: 20px;
}

:deep(h1) {
  font-size: 2.5rem;
  margin-bottom: 16px;
}
:deep(h2) {
  font-size: 2.125rem;
  margin-bottom: 16px;
}
:deep(h3) {
  font-size: 1.75rem;
  margin-bottom: 8px;
}

:deep(ol),
:deep(ul) {
  margin-bottom: 16px;
}
:deep(ol) {
  margin-left: 12px; /* for Safari */
}

:deep(a) {
  overflow-wrap: break-word;
  word-wrap: break-word;
  -ms-word-break: break-all;
  word-break: break-word;
}

:deep(blockquote) {
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 1rem;
  font-style: italic;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 50px;
  padding-left: 15px;
  border-left: 3px solid #ccc;
}
</style>
